// extracted by mini-css-extract-plugin
export default {"container":"ProfileImage_container__IuNGm","image":"ProfileImage_image__8BEZx"};